import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import InfoLanding from './InfoLanding';
import { BrowserRouter } from 'react-router-dom';
import Product from './Product';
import { Provider } from 'react-redux';
import store from './store/store';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

const stripePromise = loadStripe('pk_live_51PXbbf2NcE2VbmHR4xNQ4d7yBJfawxAUIFFP6cr9yYmJAWx3csGoFxP09Xg3v97YeOLxm319KHwUOoTW9e7G2Gyk00EIv4TMLN');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <Elements stripe={stripePromise}>
          <App />
        </Elements>
      </Provider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
